import React, { useState } from 'react';
import { 
  FaArrowRight, 
  FaLinkedin, 
  FaXTwitter, 
  FaInstagram, 
  FaYoutube 
} from 'react-icons/fa6'; 
import { HiOutlineMail } from 'react-icons/hi'; 
import { FeedCard } from '../subComponents/FeedCard';
import { SocialLink } from '../subComponents/SocialLink';

import featuredHeroImg from '../assets/ev2.jpeg';
import electricBusImg from '../assets/evlink.jpeg';
import electricBusImg1 from '../assets/evlink1.jpeg';
import Navbar from './NavBar';

const INITIAL_FEED_DATA = [
  {
    id: 1,
    category: "Strategic Partnerships",
    title: "OHM Automotives, CHTC KINWIN & CATL Partner to Revolutionize India's Electric Bus Market",
    content: "A massive shift is coming to India's public mobility landscape. We are proud to announce our strategic collaboration with KINWIN and CHTC to introduce CATL battery-powered 12-meter electric intercity buses. Powered by globally recognized CATL battery technology, these vehicles bring advanced energy density, superior thermal safety, and unparalleled total cost of ownership (TCO) efficiencies for regional transit fleet operators.",
    image: electricBusImg, 
    author: "OHM Media Desk",
    date: "May 21, 2026",
    readTime: "4 min read",
    likes: 245,
    hasLiked: false,
    isLinkedInPost: false
  },
  {
    id: 2,
    category: "LinkedIn Updates",
    title: "India’s Next Electric Bus Power Shift: Deep Ecosystem Integration",
    content: "📢 The involvement of CATL in Indian public transit raises the stakes across energy density, battery longevity, and long-term fleet operating predictability. Forward-thinking operators are no longer just looking at acquisition costs—the dialogue has permanently shifted toward asset uptime assurance and true residual lifecycle economics. Proud to see global supply giants moving directly into our transport grids. #HumansOfEV #ElectricBuses #SustainableTransit #EVMobilityIndia",
    image: null,
    author: "Humans of EV (via LinkedIn)",
    date: "May 20, 2026",
    readTime: "3 min read",
    likes: 512,
    hasLiked: false,
    isLinkedInPost: true,
    linkedInUrl: "https://linkedin.com/company/ohmautomotives"
  },
  {
    id: 3,
    category: "Product Launches",
    title: "OHM Secures Initial Order of 50 Electric Intercity Buses via CHTC & Kinwin China",
    content: "Commercial milestones unlocked. We have officially secured a pipeline order of 50 advanced 12-meter electric buses from leading fleet operators across the country. Procured through Kinwin China as CBUs and built by industry-leader CHTC China, these units will establish a new benchmark for premium intercity and intracity clean travel solutions inside India.",
    image: null,
    author: "All India EV (via LinkedIn)",
    date: "May 19, 2026",
    readTime: "2 min read",
    likes: 189,
    hasLiked: false,
    isLinkedInPost: true,
    linkedInUrl: "https://linkedin.com/company/ohmautomotives"
  },
  {
    id: 4,
    category: "Product Launches",
    title: "Introducing the OHM 12-Meter Pure Electric Intercity Coach Series",
    content: "Engineered specifically for the rigorous demands of Indian highway networks. Featuring an optimized aerodynamic chassis layout, an intelligent multi-stage regenerative braking configuration, and advanced climate control systems optimized for extreme regional weather variations—all powered seamlessly by CATL high-density cell matrix technology.",
    image: electricBusImg1, 
    author: "OHM Engineering Desk",
    date: "May 10, 2026",
    readTime: "5 min read",
    likes: 142,
    hasLiked: false,
    isLinkedInPost: false
  }
];

const CATEGORIES = ["All Updates", "Strategic Partnerships", "LinkedIn Updates", "Product Launches"];

export default function OhmFeed() {
  const [activeFilter, setActiveFilter] = useState("All Updates");
  const [feedItems, setFeedItems] = useState(INITIAL_FEED_DATA);
  const [email, setEmail] = useState("");

  const handleLike = (id) => {
    setFeedItems(prev => prev.map(item => {
      if (item.id === id) {
        return {
          ...item,
          likes: item.hasLiked ? item.likes - 1 : item.likes + 1,
          hasLiked: !item.hasLiked
        };
      }
      return item;
    }));
  };

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you for subscribing with: ${email}`);
    setEmail("");
  };

  const filteredFeed = activeFilter === "All Updates" 
    ? feedItems 
    : feedItems.filter(item => item.category === activeFilter);

  return (
    <div className="min-h-screen bg-white text-slate-900 font-sans pb-16 antialiased">
      <Navbar />
      
      {/* Editorial Crisp Header Banner */}
      <header className="text-center py-20 px-4 bg-gradient-to-b from-emerald-500/5 to-transparent">
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-emerald-50 border border-emerald-200 rounded-full text-xs font-semibold text-emerald-700 mb-4 tracking-wider uppercase">
          Live Company Ecosystem
        </div>
        <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight mb-4 text-slate-900">
          OHM <span className="text-emerald-600">Newsroom & Feed</span>
        </h1>
        <p className="text-slate-600 text-base md:text-lg max-w-2xl mx-auto font-light">
          Real-time engineering deep-dives, environmental statements, community updates, and direct streams from our public social channels.
        </p>
      </header>

      <div className="max-w-6xl mx-auto px-4 space-y-10">
        
        {/* Horizontal Category Filters */}
        <div className="flex gap-3 overflow-x-auto pb-3 scrollbar-none snap-x border-b border-slate-100">
          {CATEGORIES.map((category) => (
            <button
              key={category}
              onClick={() => setActiveFilter(category)}
              className={`px-5 py-2.5 rounded-full font-medium border text-sm transition-all duration-200 whitespace-nowrap snap-clamp
                ${activeFilter === category 
                  ? 'bg-emerald-600 text-white border-emerald-600 font-semibold shadow-md shadow-emerald-600/10' 
                  : 'bg-slate-50 text-slate-700 border-slate-200 hover:border-emerald-500/40 hover:bg-white'
                }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* High-Impact Hero Featured Card */}
        <div className="bg-slate-50 rounded-2xl border border-slate-200 overflow-hidden grid grid-cols-1 md:grid-cols-12 shadow-md relative group">
          <div className="absolute top-4 left-4 z-10">
            <span className="bg-emerald-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-sm">
              Global Vision
            </span>
          </div>
          
          <div 
            className="md:col-span-7 bg-center bg-cover min-h-[280px] md:min-h-[400px] transition-transform duration-700 group-hover:scale-[1.01]" 
            style={{ backgroundImage: `url(${featuredHeroImg})` }}
          />
          
          <div className="md:col-span-5 p-8 lg:p-12 flex flex-col justify-center items-start bg-white">
            <span className="text-emerald-600 text-xs font-semibold tracking-widest uppercase mb-3">
              Core Architecture Announcement
            </span>
            <h2 className="text-2xl lg:text-3xl font-bold leading-tight text-slate-900 mb-4">
              Unveiling the Next-Gen OHM Electric Powertrain Architecture
            </h2>
            <p className="text-slate-600 text-sm leading-relaxed mb-6">
              We are thrilled to officially introduce our new high-efficiency EV powertrain. Engineering a smarter, sustainable, and powerful tomorrow with zero compromise on heavy-performance output metrics.
            </p>
            <button className="flex items-center gap-2 px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-full text-sm font-semibold transition-all shadow-md shadow-emerald-600/10 group">
              Read Technical Specifications 
              <FaArrowRight className="text-xs transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        </div>

        {/* Split Layout Feed and Sticky Sidebar */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          
          {/* Main Feed Column */}
          <main className="lg:col-span-8 space-y-6">
            {filteredFeed.length > 0 ? (
              filteredFeed.map(post => (
                <FeedCard key={post.id} post={post} onLike={handleLike} />
              ))
            ) : (
              <div className="text-center py-16 bg-slate-50 rounded-2xl border border-slate-200 text-slate-500">
                No active announcements listed under this sector. Check back shortly.
              </div>
            )}
          </main>

          {/* Sticky Sidebar Column */}
          <aside className="lg:col-span-4 space-y-6 lg:sticky lg:top-6">
            
            {/* Sustainability Stats Widget */}
            <div className="bg-slate-50 rounded-2xl border border-slate-200 p-6 shadow-sm">
              <h3 className="text-sm font-bold text-emerald-700 tracking-widest uppercase mb-4">
                Ohm Impact Metrics
              </h3>
              <div className="space-y-4">
                <div>
                  <div className="text-2xl font-bold text-slate-900">0g CO₂/km</div>
                  <div className="text-xs text-slate-500">Tailpipe Emissions Across All Lines</div>
                </div>
                <div className="pt-3 border-t border-slate-200">
                  <div className="text-2xl font-bold text-slate-900">100% Green</div>
                  <div className="text-xs text-slate-500">Renewable Manufacturing Energy Source</div>
                </div>
              </div>
            </div>

            {/* Newsletter Subscription Widget */}
            <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
              <h3 className="text-base font-semibold border-b border-slate-100 pb-3 mb-4 flex items-center gap-2 text-slate-900">
                <HiOutlineMail className="w-5 h-5 text-emerald-600" /> Subscribe to Ohm Insights
              </h3>
              <p className="text-slate-600 text-xs mb-4 leading-relaxed">
                Receive high-impact press distributions, corporate engineering statements, and early prototype priority updates directly.
              </p>
              <form onSubmit={handleNewsletterSubmit} className="space-y-3">
                <input 
                  type="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="name@company.com" 
                  className="w-full px-4 py-2.5 rounded-lg border border-slate-200 bg-slate-50 text-slate-900 text-sm focus:outline-none focus:border-emerald-500 focus:bg-white transition-colors placeholder-slate-400"
                  required
                />
                <button type="submit" className="w-full py-2.5 bg-emerald-600 hover:bg-emerald-700 active:scale-[0.99] text-white font-bold rounded-lg text-sm transition-all shadow-sm">
                  Join Press List
                </button>
              </form>
            </div>

            {/* Social Channels Ecosystem Widget */}
            <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
              <h3 className="text-base font-semibold border-b border-slate-100 pb-3 mb-3 text-slate-900">
                Corporate Channels
              </h3>
              <div className="divide-y divide-slate-100">
                <SocialLink href="https://linkedin.com/company/ohmautomotives" label="LinkedIn Corporate Hub" Icon={FaLinkedin} />
                <SocialLink href="#" label="X / Twitter Updates" Icon={FaXTwitter} />
                <SocialLink href="#" label="Instagram Media" Icon={FaInstagram} />
                <SocialLink href="#" label="YouTube Launch Keynotes" Icon={FaYoutube} />
              </div>
            </div>

          </aside>

        </div>
      </div>
    </div>
  );
}